import { forwardRef } from 'react'
import { StyledTextarea } from './styles'
import { TextareaProps } from './props'

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ css, resize, ...props }, ref) => (
        <StyledTextarea {...props} css={{ ...css, resize: resize }} ref={ref} />
    )
)

Textarea.displayName = 'Textarea'

export default Textarea

export { StyledTextarea }
